import TomSelect from 'tom-select';

// The inline init in templates/partial-tomselect.php (and any future callers) use these
// globals; the lowercase factory used to live as a line hand-appended to the vendored
// tomselect-*.min.js file.
window.TomSelect = TomSelect;
window.tomSelect = function(element, settings) {
    return new TomSelect(element, settings);
};
